<div class="custom-shape-divider-top-1744242974">
</div>
<div class="sticky top-0 flex flex-wrap justify-content-center align-items-center menu" *ngIf="infoEmpresa.length > 0"
    style="z-index:100">
    <div class="w-1 flex align-items-center">
        <p-button type="text" (click)="display = true" icon="pi pi-bars"></p-button>
    </div>
    <div class="w-11 flex flex-wrap">
        <div
            class="w-11 {{infoUser.idPerfil ==5 ?'md:w-4':'md:w-6'}} text-uppercase text-center flex align-items-center justify-content-center">
            <b>Empresa:&nbsp;
            </b>{{infoEmpresa.length ===0 ? ""
            :infoEmpresa[0].idProveedorNavigation.razonSocial }}
        </div>
        <div class="w-full md:w-4 sw:text-right text-center text-uppercase flex align-items-center justify-content-center"
            *ngIf="infoUser.idPerfil ==5">
            <b>Tienda: </b>{{ !
            infoEmpresa[0].hasOwnProperty('tiendaEmpleados')? "" :
            infoEmpresa[0].tiendaEmpleados[0].idTiendaNavigation.nombreTienda}}
        </div>
        <div class="w-full md:w-4 text-right text-uppercase flex align-items-center justify-content-center">
            <b>Bienvenido:</b>&nbsp;{{infoUser.nombres + "
            " +
            infoUser.apellidos}} <button pButton icon="pi pi-power-off" class="p-button p-button-link text-white"
                (click)="closeSession()"></button>
        </div>
        <div class="w-full text-center uppercase p-2 ">
            <h4 class="uppercase p-0 m-0 text-white">{{title}}</h4>
        </div>
    </div>

</div>
<p-drawer [(visible)]="display">
    <div class="text-center">
        <!--<img src="assets/img/logoSimescco.jpg" class="logo">-->
        <img [src]="infoParametrizacion?.logoImg" class="logo">
    </div>
    <p-divider></p-divider>
    <h4 class="colorSimescco2">Menu</h4>
    <p class="font8 colorWhite">Accesos directos al sistema</p>
    <p-panelMenu [model]="menu" [multiple]="true">
    </p-panelMenu>
    <div class="text-center pt-4">
        <button pButton icon="pi pi-power-off" class="p-button p-button-danger" label="Cerrar sesión"
            (click)="closeSession()"></button>
    </div>
</p-drawer>
